"use client";
import { useRef } from "react";
import { Container, SectionTitle, SplitText } from "@/components";
import { useTextReveal } from "@/hooks/animations/useTextReveal";

const CaseStudySummary = ({
  summaryStatement,
}: {
  summaryStatement: string;
}) => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useTextReveal(sectionRef, ".summary", true);
  return (
    <section ref={sectionRef} className="lg:pb-10 pb-6">
      <Container className="px-6 lg:px-16">
        <div className="mx-auto">
          <SectionTitle
            title={SplitText(summaryStatement)}
            className="summary text-black text-md md:text-xl xl:text-3xl lg:leading-10 tracking-normal"
          />
        </div>
      </Container>
    </section>
  );
};

export default CaseStudySummary;
